import formatDate from '../../utils/formatDate';
import EnhanceButton from './EnhanceBlogPostButton';
import MoreInfo from './MoreInfo';

export default function B3({ post, setPost }) {
	return (
		<div className='bg-white px-6 py-20 lg:px-8'>
			<div className='mx-auto max-w-3xl text-base leading-7 text-gray-700'>
				<EnhanceButton
					setPost={setPost}
					post={post}
				/>
				<p className='text-base font-semibold leading-7 text-primary-600'>
					{formatDate(post.createdAt)}
				</p>
				<h1 className='mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl'>
					{post.title}
				</h1>
				<div className='mt-10 max-w-2xl'>
					<p>{post.description}</p>
				</div>
				<figure className='mt-16'>
					<img
						className='aspect-video rounded-xl bg-gray-50 object-cover'
						src={post.img}
						alt=''
					/>
				</figure>
				<div className='mt-16 max-w-2xl'>
					{post.sections &&
						post.sections.map((section, i) => (
							<div key={i}>
								<h2 className='mt-10 text-2xl font-bold tracking-tight text-gray-900'>
									{section.title}
								</h2>
								<p className='mt-6'>{section.body}</p>
							</div>
						))}
				</div>
				<p className='mt-6'>{post && post?.conclusion}</p>
				<MoreInfo />
			</div>
		</div>
	);
}
